import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { of } from 'rxjs/observable/of';
import { catchError, tap } from 'rxjs/operators';

// import { UsuarioSio } from '../base/vo/usuario-sio';
// import { EsqueceuSenhaComponent } from '../esqueceu-senha/esqueceu-senha.component';
import * as $ from 'jquery';
import { isNullOrUndefined } from 'util';

import { AdminConfigsService } from '../admin/configs/admin-configs.service';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { PerfilEnum } from '../base/enum/perfil';
import { URL_INSTITUCIONAL } from '../base/util/url-util';
import { Configs } from '../base/vo/configs';
import { Usuario } from '../base/vo/usuario';
import { DadosPrestadorService } from '../dados-prestador/dados-prestador.service';
import { ModalDocumentoService } from '../modal-documentos/modal-documentos.service';
import { PopupService } from '../popup/popup.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public usuario = new Usuario();

  // public usuario_sio = new UsuarioSio();

  public usuarioIsNull = false;
  public senhaIsNull = false;

  // public usuario_sioIsNull = false;
  // public senha_sioIsNull = false;
  // public estado_sioIsNull = false;

  public isSenhaOrUsuarioInvalido = false;

  public messagemErroLogin: string;
  public loading = false;

  public loadingSio = false;

  public urlInstitucional = URL_INSTITUCIONAL;

  public configs: Configs = new Configs();
  public loadingConfigs = true;

  // public caracteristicas: string;

  constructor(
    private adminConfigsService: AdminConfigsService,
    private autenticacaoService: AutenticacaoService,
    private dadosPrestadorService: DadosPrestadorService,
    private modalDocumentoService: ModalDocumentoService,
    private popupService: PopupService,
    private router: Router
    ) {  }

  ngOnInit() {
    // this.caracteristicas = this.getInfoUser();

    this.popupService.control = false;
    this.modalDocumentoService.control = false;

    if (this.autenticacaoService.isUsuarioLogado()) {
      this.redirectPaginaInicial(this.autenticacaoService.usuarioLogado);
      return;
    }

    this.adminConfigsService.buscarConfigsLogin().pipe(
      tap(response => {
        this.configs = response.data;
        this.loadingConfigs = false;
      }),
      catchError(error => {
        this.loadingConfigs = false;

        return of(error);
      })
    ).subscribe();

  }

  public onSubmit() {
    this.usuarioIsNull = this.isVazio(this.usuario.username);
    this.senhaIsNull = this.isVazio(this.usuario.password);

    if (this.usuarioIsNull === false || this.senhaIsNull === false) {
      this.login();
    }
  }


  // public onSubmitSio() {
  //   this.usuario_sioIsNull = this.isVazio(this.usuario_sio.login);
  //   this.senha_sioIsNull = this.isVazio(this.usuario_sio.senha);
  //   if (this.usuario_sioIsNull == false || this.senha_sioIsNull == false) {
  //     this.login();
  //   }
  // }

  // public onSubmitSio() {
  //   this.usuario_sioIsNull = this.isVazio(this.usuario_sio.login);
  //   this.senha_sioIsNull = this.isVazio(this.usuario_sio.senha);
  //   this.estado_sioIsNull = this.isVazio(this.usuario_sio.codigo);
  //   if (this.usuario_sioIsNull == false || this.senha_sioIsNull == false || this.estado_sioIsNull == false) {
  //     this.loginSite();
  //   }
  // }

  public esqueciSenhaSio() {
    // this.usuario_sioIsNull = this.isVazio(this.usuario_sio.login);
    // // this.senha_sioIsNull = this.isVazio(this.usuario_sio.senha);
    // this.estado_sioIsNull = this.isVazio(this.usuario_sio.codigo);

    // if (this.usuario_sioIsNull == false || this.estado_sioIsNull == false) {
    this.esqueciMinhaSenha();
    // }
  }

  private isVazio(campo: string): boolean {
    if (isNullOrUndefined(campo)) {
      return true;
    }

    if (campo.length <= 0) {
      return true;
    } else {
      return false;
    }

  }

  public login() {
    this.loading = true;

    this
      .autenticacaoService
      .login(this.usuario)
      .subscribe(
        data => this.callbackSucessoLogin(data),
        erro => this.callbackErroLogin(erro)
      );
  }

  // public loginSio() {
  //   this.loadingSio = true;
  //   this
  //     .autenticacaoService
  //     .loginSio(this.usuario_sio)
  //     .subscribe(data => this.callbackSucessoLogin(data),
  //       erro => this.callbackErroLogin(erro));
  // }

  public loginSite() {
    this.loadingSio = true;


    // validações aqui
    if (typeof (Storage) !== 'undefined') {
      sessionStorage.setItem('ss', '1');
      localStorage.setItem('ls', '1');
    } else {
      sessionStorage.setItem('ss', '1');
      // store.set('ls', '1');
    }

    // $('#form_login').attr('action', 'https://www.unioweb.com.br/UnimedOdontoHomolog/LoginSite.do');
    $('#form_login').attr('action', 'https://www.unioweb.com.br/UnimedOdonto/LoginSite.do');
    $('#form_login').attr('method', 'GET');
    $('#form_login').submit();

  }

  callbackSucessoLogin(usuario: Usuario) {
    if (usuario) {
      this.autenticacaoService.limparBuscaGto();

      if (usuario.perfil === PerfilEnum.ADMIN || usuario.perfil === PerfilEnum.MARKETING) {
        this.redirectPaginaInicial(usuario);
      } else {
        this.dadosPrestadorService.carregarImagemPerfil().subscribe(data => {
          this.redirectPaginaInicial(usuario);
        });
      }
    } else {
      this.router.navigate(['/login']);
    }
  }

  redirectPaginaInicial(usuario: Usuario) {
    switch (usuario.perfil) {
      case PerfilEnum.ADMIN:
        this.router.navigate(['/admin/configs']);
        break;
      case PerfilEnum.MARKETING:
        this.router.navigate(['/admin/comunicados']);
        break;
      case PerfilEnum.PRESTADOR:
        this.router.navigate(['/dashboard']);
        break;
    }
  }

  callbackErroLogin(erro: any) {
    this.loading = false;
    let listErrors: any;
    listErrors = erro.error.errors;

    if (listErrors) {
      for (let index = 0; index < listErrors.length; index++) {
        if (listErrors[index].field === 'not_found') {
          this.messagemErroLogin = 'Usuário e/ou senha não confere(m)!';
          this.isSenhaOrUsuarioInvalido = true;
          return;
        }
      }
    }

    this.messagemErroLogin = 'Erro ao tentar entrar, tente novamente mais tarde';
    this.isSenhaOrUsuarioInvalido = true;

  }

  onInputValueChange(nomeCampo: string) {
    if (nomeCampo === 'username') {
      this.usuarioIsNull = false;
    }
    if (nomeCampo === 'password') {
      this.senhaIsNull = false;
    }

  }

  // public somenteNumeros(e) {
  //   var charCode = e.charCode ? e.charCode : e.keyCode;
  //   // charCode 8 = backspace
  //   // charCode 9 = tab
  //   if (charCode !== 8 && charCode !== 9) {
  //     // charCode 48 equivale a 0
  //     // charCode 57 equivale a 9
  //     if (charCode < 48 || charCode > 57) {
  //       return false;
  //     }
  //   }
  // }



  public esqueciMinhaSenha() {

    // console.log($('#form_login').serialize());
    $('#caracteristicas').val('');
    $('#pswrd').val('');
    $('#form_login').attr('action', 'https://www.unioweb.com.br/UnimedOdontoHomolog/Login.do?dicaDeSenha=true');
    $('#form_login').submit();

  }

  public getInfoUser() {
    const array = new Array();
    let plugin = '';
    let conta = 0;
    let indice = 0;

    for (let i = 0; i < navigator.plugins.length; i++) {
      if (i === 0) {
        array[indice] = navigator.plugins[i];
      } else {
        for (let j = 0; j < array.length; j++) {
          if (navigator.plugins[i].name === array[j].name) {
            conta++;
            break;
          }
        }
        if (conta === 0) {
          indice++;
          array[indice] = navigator.plugins[i];
        }
      }
      conta = 0;
    }
    for (let f = 0; f < array.length; f++) {
      if (array[f] != null) {
        plugin += array[f].name + ';';
      }
    }

    const infoUser = 'Browser CodeName: ' + navigator.appCodeName + '/ ' +
      'Browser Name: ' + navigator.appName + '/ ' +
      'Browser Version: ' + navigator.appVersion + '/ ' +
      'Cookies Enabled: ' + navigator.cookieEnabled + '/ ' +
      'Platform: ' + navigator.platform + '/ ' +
      'User-agent header: ' + navigator.userAgent + '/' +
      'Resolução: ' + screen.width + 'x' + screen.height + '/' +
      'Plugins: ' + plugin;
    return infoUser;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts